import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from '../models/userModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../environments/environment';
// import { AngularFireAuth } from 'angular/fire/auth';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { auth } from 'firebase/app';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public userLogin = new BehaviorSubject<any>({});
  private isSubscribed = new BehaviorSubject(false);
  bhours;


  getIsProfileUpdate() {
    return this.isSubscribed.asObservable();
  }
  setIsProfileUpdate(data: boolean) {
    this.isSubscribed.next(data)
  }

  public currentUser1: Observable<User>;
  constructor(
    public router: Router,
    private http: HttpClient,
    public afAuth: AngularFireAuth,
    public ngZone: NgZone,
    public datePipe: DatePipe
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('merchant_currentUser1'))
    );
    this.currentUser1 = this.currentUserSubject.asObservable();
  }

  SharingData = new Subject();

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }


  authenticateWithUrlToken(token: string): boolean {
    try {
      const helper = new JwtHelperService();
      const isExpired = helper.isTokenExpired(token);

      if (!isExpired) {
        const decodedToken = helper.decodeToken(token);

        // Save token + user info
        localStorage.setItem('merchant_token', token);
        localStorage.setItem('merchant_currentUser1', JSON.stringify(decodedToken));
        this.currentUserSubject.next(decodedToken);

        return true;
      } else {
        console.warn("URL token is expired");
        return false;
      }
    } catch (err) {
      console.error("Invalid token from URL", err);
      return false;
    }
  }


  // Firebase SignInWithPopup
  OAuthProvider(provider) {
    return this.afAuth
      .signInWithPopup(provider)
      .then((res) => {
        this.ngZone.run(() => {
          this.router.navigate(['profile']);
        });
      })
      .catch((error) => {
        window.alert(error);
      });
  }

  spilturl(image: any) {
    let url = environment.basePath;
    // let url = 'https://services.ravel.faith/'
    if (image == null || image == '') {
      return image;
    } else {
      let mainUrl;

      let imgarray = image.split('/');
      if (imgarray[0] == 'uploads') {
        mainUrl = url + image;
        return mainUrl;
      }
      return image;
      // if (imgarray[0] == "http:") {
      //   return image;
      // } else {
      //   mainUrl = url + imgarray.join("/");

      //   return mainUrl;
      // }
    }
  }

  doFacebookLogin() {

    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.FacebookAuthProvider();
      this.afAuth.signInWithPopup(provider).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }
  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      console.log(provider)
      this.afAuth.signInWithPopup(provider).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  GetToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.afAuth.onAuthStateChanged((user) => {
        if (user) {
          user.getIdToken().then((idToken) => {
            let userToken = idToken;
            resolve(userToken);
          });
        }
      });
    });
  }
  xAccessToeknHeader() {
    let currentUser1 = localStorage.getItem('merchant_token');
    let headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    headers = headers.append('Authorization', 'Bearer ' + currentUser1);
    headers.append('Origin', environment.baseUrl);
    let options = {
      headers: headers,
    };
    return options;
  }

  updateDataToLocal(data: {}) {
    let currentUser1 = this.currentUserSubject.value;
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        currentUser1[key] = data[key];
      }
    }
    localStorage.setItem('merchant_currentUser1', JSON.stringify(currentUser1));
  }
  signUp(obj) {
    return this.http.post<any>(`${environment.baseUrl}/auth/signup`, obj).pipe(
      map((user) => {
        user = user.data;
        console.log(user);
        if (user && user.token) {
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(user.token);
          localStorage.setItem('merchant_token', user.token);
          localStorage.setItem('merchant_currentUser1', JSON.stringify(decodedToken));
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  login(obj) {
    return this.http.post<any>(`${environment.baseUrl}/auth/login`, obj).pipe(
      map((user) => {
        user = user.data;
        if (user && user.token) {
          localStorage.clear();
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(user.token);
          localStorage.setItem('merchant_token', user.token);
          localStorage.setItem('merchant_currentUser1', JSON.stringify(decodedToken));
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }
  public user: any;
  getMerchantById(id) {
    let options = this.xAccessToeknHeader();
    return this.http
      .get(`${environment.baseUrl}/merchant/getMerchantByID/` + id, options)
      .pipe(
        map((user) => {
          this.user = user['data'];
          console.log(this.user);
          return user;
        })
      );
  }
  userRegistration(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/registerMerchant`,
      data,
      options
    );
  }
  deleteAccount() {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/deleteProfile`,
      {},
      options
    );
  }
  disableAccount(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/disableProfile`,
      data,
      options
    );
  }
  updateProfile(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/secondupdate`,
      data,
      options
    );
  }
  profilePolicy(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/profilePrivacy`,
      data,
      options
    );
  }
  logout() {
    localStorage.removeItem('merchant_currentUser1');
    localStorage.removeItem('description');
    localStorage.removeItem('mystatus');
    this.currentUserSubject.next(null);
    this.router.navigateByUrl('/login');
    // location.reload();
    // let currentUser1 = localStorage.getItem("token");
    // let headers = new HttpHeaders().set(
    //   "Content-Type",
    //   "application/json; charset=utf-8"
    // );
    // headers = headers.append("x-access-token", currentUser1);
    // let options = {
    //   headers: headers
    // };
    // localStorage.removeItem("token");
    // localStorage.removeItem("merchant_currentUser1");
    // this.currentUserSubject.next(null);
    // return this.http.post(`${environment.baseUrl}/user/logout`, {}, options);
  }

  register(data) {
    let headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    let options = {
      headers: headers,
    };
    return this.http.post(`${environment.baseUrl}/auth/signup`, data, options);
  }

  forgotPassword(data) {
    let currentUser1 = localStorage.getItem('merchant_token');
    let headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + currentUser1
    );
    let options = {
      headers: headers,
    };
    return this.http.post(
      `${environment.baseUrl}/auth/generateOTP`,
      data,
      options
    );
  }

  changePassword(data) {
    let headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    let options = {
      headers: headers,
    };
    return this.http.post(
      `${environment.baseUrl}/auth/changePassword`,
      data,
      options
    );
  }

  loginWithSocailMedia(data) {
    return this.http
      .post<any>(`${environment.baseUrl}/auth/socialLogin`, data)
      .pipe(
        map((user) => {
          user = user.data;
          console.log(user, '##########');
          if (user && user.token) {
            const helper = new JwtHelperService();
            const decodedToken = helper.decodeToken(user.token);
            localStorage.setItem('merchant_token', user.token);
            localStorage.setItem('merchant_currentUser1', JSON.stringify(decodedToken));
            this.currentUserSubject.next(user);
          }
          return user;
        })
      );
  }
  uploadImage(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/updateEmail`,
      data,
      options
    );
  }
  updateEmail(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/updateEmail`,
      data,
      options
    );
  }
  resendEmail(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/resendEmail`,
      data,
      options
    );
  }
  verifyEmail(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/verifyEmail`,
      data,
      options
    );
  }
  addNewUser(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(`${environment.baseUrl}/user/addUser`, data, options);
  }

  getUserData(id) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/user/getProfileData/` + id,
      options
    );
  }

  updateUser(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/user/updateProfileData`,
      data,
      options
    );
  }
  getProfile() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getMerchant`,
      options
    );
  }

  getMerchantInquiries() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getInquiries`,
      options
    );
  }

  updateInquiryStatus(data: { inquiryId: string; status: string }) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/updateInquiryStatus`,
      data,
      options
    );
  }

  getProfileByUsername(businessUserName) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getmerchantbyusername/` + businessUserName,
      options
    );
  }

  mysubscription(skip, limit) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getMerchantPlans?skip=${skip}&limit=${limit}`,
      options
    );
  }

  requestKingdomPartner() {
    let options = this.xAccessToeknHeader();

    return this.http.post(
      `${environment.baseUrl}/merchant/requestKingdomPartner`,
      {},
      options
    );
  }

  cancelKingdomPartnerRequest() {
    let options = this.xAccessToeknHeader();

    return this.http.post(
      `${environment.baseUrl}/merchant/cancelKingdomPartnerRequest`,
      {},
      options
    );
  }

  getGalleryImages(skip: number = 0, limit: number = 10) {
    let options = this.xAccessToeknHeader();
    return this.http.get(`${environment.baseUrl}/admin/gallery?skip=${skip}&limit=${limit}`, options);
  }
  onphotoGallery() {
    let options = this.xAccessToeknHeader();
    return this.http.get(`${environment.baseUrl}/common/gallery`, options);
  }

  submitPhotoGallery(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/gallery`,
      data,
      options
    );
  }

  updatePhotoGallery(data) {
    let options = this.xAccessToeknHeader();

    return this.http.post(
      `${environment.baseUrl}/common/update/gallery`,
      data,
      options
    );
  }

  getLocations() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/subscriptions/statuses`,
      options
    );
  }
  addAdvertisement(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/createoffer`,
      data,
      options
    );
  }
  getAdvertisement() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getofferbymerchant`,
      options
    );
  }

  deleteAds(id) {
    let options = this.xAccessToeknHeader();
    return this.http.delete(
      `${environment.baseUrl}/merchant/deleteOffer/` + id,
      options
    );
  }

  perpetualAdd(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/perpetualAdd`,
      data,
      options
    );
  }
  getPerpetualAdd() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/perpetualAdd`,
      options
    );
  }

  gallery(skip, limit) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/gallery?skip=${skip}&limit=${limit}`,
      options
    );
  }

  getUserSubscriptions() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/payment/getSubscription`,
      options
    );
  }

  requestPayment = (data) => {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/payments`,
      data,
      options
    );
  };
  basicSubscription = (data) => {
    // let options = this.xAccessToeknHeader();
    // return this.http.post(
    //   `${environment.baseUrl}/merchant/subscription/basic`,
    //   data,
    //   options
    // );
    let options = this.xAccessToeknHeader();
    return this.http.post(`${environment.baseUrl}/merchant/subscription/basic`, data, options).pipe(
      tap((response: any) => {
        if (response?.couponId) {
          localStorage.setItem('couponId', response.couponId);
        }
      })
    );
  };

  getCouponId = (id: any) => {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/coupons/${id}`,
      options
    );
  }

  bannerSubscription = (data: any) => {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/subscription/banner`,
      data,
      options
    );
  }

  getSubscription() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/getSubscription`,
      options
    );
  }
  validateSubscription(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/subscription/validate`,
      data,
      options
    );
  }
  coupon(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/validate/coupon`,
      data,
      options
    );
  }
  cardList() {
    let options = this.xAccessToeknHeader();
    return this.http.get(`${environment.baseUrl}/cards/list`, options);
  }
  addCard(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(`${environment.baseUrl}/addCard`, data, options);
  }
  removeCard(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(`${environment.baseUrl}/removeCard`, data, options);
  }
  // deleteCard(cardID) {
  //   let options = this.xAccessToeknHeader();
  //   return this.http.post(
  //     `${environment.baseUrl}/removeCard`,
  //     { cardId: cardID },
  //     options
  //   );
  // }

  setCardAsDefault(data) {
    let options = this.xAccessToeknHeader();
    return this.http.put(`${environment.baseUrl}/udpateCard`, data, options);
  }

  getPlansAmount() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/payment/getPlansAmount`,
      options
    );
  }

  cancelSubscription = (body) => {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/payment/cancelSubscription`,
      body,
      options
    );
  };

  cancelmerchantSubscription = (body) => {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/cancelsubscription`,
      body,
      options
    );
  };
  cancelCommonMerchantSubscription = (body: any) => {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/commonMerchant/cancelsubscription`,
      body,
      options
    );
  };

  createBusinessHours(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/createBussinessHours`,
      data,
      options
    );
  }
  editPlansAmount(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/payment/editPlansAmount`,
      data,
      options
    );
  }

  geoLocationValidator(data) {
    let headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    let options = {
      headers: headers,
    };
    return this.http.post(
      `${environment.baseUrl}/html/geoLocationValidator`,
      data,
      options
    );
  }
  getPlan(type) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/getTimes?basePrice=` + type
    );
  }
  getFaith() {
    let options = this.xAccessToeknHeader();
    let skip = 0;
    let limit = 10000;
    return this.http.get(
      `${environment.baseUrl}/comman/getfaiths?skip=` + skip + `&limit=` + limit
    );
  }

  getBusinessType(search: any) {
    let options = this.xAccessToeknHeader();
    let skip = 0;
    let limit = 10000;
    return this.http.get(
      `${environment.baseUrl}/comman/getBussinessType?skip=` +
      skip +
      `&limit=` +
      limit +
      `&search=` +
      search
    );
  }

  getBannerCategory() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/bannerCategory`,
      options
    );
  }

  getVisitors() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/visitorslist`,
      options
    );
  }
  getCommunity(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/community/claim/serachlist`,
      data,
      options
    );
  }

  getCommunities(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/community/claim/list`,
      data,
      options
    );
  }
  getFollowers(data) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getfollowers?skip=` +
      data.skip +
      `&limit=` +
      data.limit,
      options
    );
  }

  getGallery(data) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/gallery?skip=` +
      data.skip +
      `&limit=` +
      data.limit,
      options
    );
  }

  getcampusGreeting() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/welcomeMessage`,
      options
    );
  }
  campusGreeting(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/welcomeMessage`,
      data,
      options
    );
  }

  successMessage(msg, type) {
    return Swal.fire({
      icon: type,
      title: msg,
    });
  }

  scrollToError(): void {
    setTimeout(() => {
      let firstElementWithError;

      firstElementWithError = document.querySelector('.invalid-feedback');

      firstElementWithError.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 0);
  }

  upload(data) {
    // let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/comman/fileHandler`,
      data
      // ,
      // options
    );
  }
  SetSharindFlag = new Subject();
  // sendDataToOtherComponent(somedata){
  //   this.firstSignup.next(somedata);
  // }
  BusinessData(day) {
    console.log(day, 'testing')
    let displayDate = '';
    var Days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    var d = new Date();
    var dayName = Days[d.getDay()];
    let finalArr = [];
    let displayData;
    for (var key in day) {
      if (Days.includes(key)) {
        let inner = day[key];
        let innerTimer = [];
        for (var time = 0; time < inner.length; time++) {
          if (inner[time].Finish != '') {
            innerTimer.push({
              Start: inner[time].Start,
              Finish: inner[time].Finish,
            });
          }
        }
        if (innerTimer.length > 0) {
          finalArr.push({ day: key, time: innerTimer });
        }
      }
    }

    if (finalArr.some((person) => person.day === dayName)) {
      displayData = finalArr.find(({ day }) => day === dayName);
    } else {
      displayData = finalArr[0];
    }
    var sdate = this.datePipe.transform(
      displayData?.time[0]?.Start,
      'MMM d, y, h:mm:ss a'
    );
    var fdate = this.datePipe.transform(
      displayData?.time[0]?.Finish,
      'MMM d, y, h:mm:ss a'
    );
    displayDate = `${displayData?.day} : Start :  ${sdate}, End ${fdate}`;
    return displayDate;
  }

  // getSubscriptionPlans() {
  //   let options = this.xAccessToeknHeader();
  //   return this.http.get(
  //     `${environment.baseUrl}/merchant/subscriptionPlans`,
  //     options
  //   );
  // }

  // getMySubscriptionPlan

  getMySubscriptionPlan() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/mySubscriptionPlan`,
      options
    );
  }

  // updateUserSubscription
  updateUserSubscription(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.put(
      `${environment.baseUrl}/merchant/updateUserSubscription`,
      data,
      options
    );
  }

  getSubscriptionById(id: any) {
    console.log("id>>>>>>>>>>>>.....", id)
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/subscriptionPlan/${id}`,
      options
    );
  }



  getUserInfo(user: any) {
    this.userLogin.next(user.data);
  }

  // Hide Merchant Address
  hideMerchantAddress(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/hideaddress`,
      data,
      options
    );
  }

  contactMessages(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}`,
      options
    );
  }

  //markAsRead to read all messages
  markAsRead(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}${url}`, '',
      options
    );
  }


  //markAsRead to read all messages
  followersList(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}`,
      options
    );
  }


  // getPostMessages by id
  getPostMessages(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}`,
      options
    );
  }

  contactUsMessage(obj: any) {
    console.log('--obj', obj)
    let options = this.xAccessToeknHeader();
    return this.http
      .post<any>(`${environment.baseUrl}/postChat/contactUs/${obj.postId}`, obj, options)
      .pipe(
        map((user: any) => {
          user = user.data;
          return user;
        })
      );
  }

  searchMerchantForChat(url: string, obj: any) {
    let options = this.xAccessToeknHeader();
    return this.http
      .post<any>(`${environment.baseUrl}${url}`, obj, options)
      .pipe(
        map((data: any) => {
          data = data;
          return data;
        })
      );
  }




  createPostCard(data: Object) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/announcement`,
      data,
      options
    );
  }

  getAllAnnouncment(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}`,
      options
    );
  }

  getPostCards(skip, limit, mine) {
    return this.http.get(
      `${environment.baseUrl}/community/getAllAnnouncement?skip=${skip}&limit=${limit}&mine=${mine}`,
      this.xAccessToeknHeader()
    );
  }

  getMyPostcards(skip, limit, mine) {
    return this.http.get(
      `${environment.baseUrl}/community/events?skip=${skip}&limit=${limit}&mine=${mine}`,
      this.xAccessToeknHeader()
    );
  }

  createLog(data: Object) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/activityLogUsers`,
      data,
      options
    );
  }


  getCommonSubscriptionPlanById(id: any) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/getTime/${id}`,
      options
    );
  }


  deletePerpetualAdd(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/deletePerpetualAdd`,
      data,
      options
    );
  }


  createMerchantEvent(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/createEvent`,
      data,
      options
    );
  }

  createJob(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/jobPost`,
      data,
      options
    );
  }

  getJobPosts() {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/jobPosts`,
      {},
      options
    );
  }

  updateJob(id: string, data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.put(
      `${environment.baseUrl}/jobPost/${id}`,
      data,
      options
    );
  }

  addHousingPost(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/addHousingPost`,
      data,
      options
    );
  }

  getMyHousingPosts() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/getMyHousingPosts`,
      options
    );
  }

  updateHousingPost(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/updateHousingPost`,
      data,
      options
    );
  }

  updateMerchantEvent(eventData: any, eventId: string) {
    let options = this.xAccessToeknHeader();
    return this.http.put(
      `${environment.baseUrl}/merchant/updateEvent/${eventId}`,
      eventData,
      options
    );
  }

  getAllMerchantEvents() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/allMerchantEvents`,
      options
    );
  }

  getMerchantEventById(eventId: string, eventData: any) {
    console.log("evenData: ", eventData);
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/merchantEvent/detail/${eventId}`,
      eventData
    );
  }
  // /api/user/merchantEvent/detail/:id

  getnotifications(skip, limit) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/getnotifications/?skip=${skip}&limit=${limit}`,
      options
    );
  }

  getUnreadNotificationCount() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/getunreadnotificationcount`,
      options
    );
  }

  markNotificationAsRead(id: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/isNotificationRead/${id}`,
      options
    );
  }

  postData(url: string, data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      environment.baseUrl + url,
      data,
      options
    );
  }

  getData(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      environment.baseUrl + url,
      options
    );
  }

  getAllResources(skip, limit) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/getAllResourceLinks?skip=${skip}&limit=${limit}`,
      options
    );
  }
  getPlanById(id: any) {
    return this.http.get(
      `${environment.baseUrl}/comman/getTime/${id}`
    );
  }
  getBannerPlans() {
    return this.http.get(
      `${environment.baseUrl}/comman/bannerplans/list`
    );
  }
  getBannerDetail() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/bannerDetail`, options
    );
  }
  getBannerPlanById(id: any) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/comman/bannerplans/${id}`,
      options
    );
  }

  getBannerAds(skip, limit) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/banner/list?skip=${skip}&limit=${limit}`,
      options
    );
  }
  getBannerAd(id: any) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/merchant/banner/` + id,
      options
    );
  }
  deleteBannerAd(id) {
    let options = this.xAccessToeknHeader();
    return this.http.delete(
      `${environment.baseUrl}/merchant/banner/` + id,
      options
    );
  }
  deleteBanner() {
    let options = this.xAccessToeknHeader();
    return this.http.delete(
      `${environment.baseUrl}/merchant/deleteBanner`,
      options
    );
  }
  cancelBannerSubscription(id) {
    let options = this.xAccessToeknHeader();
    return this.http.delete(
      `${environment.baseUrl}/merchant/subscription/banner/` + id,
      options
    );
  }
  getUserFollowing(url: String, params?: any) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}?skip=${params.skip}&limit=${params.limit}&type=${params.type}&search=${params.search}`,
      options
    );
  }

  activateUser() {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/user/activateUser`,
      {},
      options
    );
  }
  getMerchantAnalytics(merchantId: string) {
  let options = this.xAccessToeknHeader();
  return this.http.get(
    `${environment.baseUrl}/merchant/analytics/${merchantId}`,
    options
  );
}

  trackAnalytics(merchantId: string, field: string, platform?: string) {
    let options = this.xAccessToeknHeader();
    const body: any = { field };
    if (platform) {
      body.platform = platform;
    }
    return this.http.post(
      `${environment.basePath}api/merchant/trackAnalytics/${merchantId}`,
      body,
      options
    );
  }

  getMerchantInsights(merchantId: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.basePath}api/merchant/insights/${merchantId}`,
      options
    );
  }

  trackEventView(eventId: string) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.basePath}api/merchant/trackEventView/${eventId}`,
      {},
      options
    );
  }
  
 getMerchantLeads(
  merchantId: string,
  page: number = 1,
  limit: number = 10
) {
  const options = this.xAccessToeknHeader();

  return this.http.get(
    `${environment.baseUrl}/lead-generation/merchant-leads?merchantId=${merchantId}&page=${page}&limit=${limit}`,
    options
  );
}

markLeadContacted(leadId: string) {
  const options = this.xAccessToeknHeader();
  return this.http.put(
    `${environment.baseUrl}/lead-generation/merchant-leads/${leadId}/contact`,
    {},
    options
  );
}

archiveLead(leadId: string) {
  const options = this.xAccessToeknHeader();
  return this.http.put(
    `${environment.baseUrl}/lead-generation/merchant-leads/${leadId}/archive`,
    {},
    options
  );
}

deleteLead(leadId: string) {
  const options = this.xAccessToeknHeader();
  return this.http.delete(
    `${environment.baseUrl}/lead-generation/merchant-leads/${leadId}`,
    options
  );
}

  paySubscription(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/merchant/subscription/paynow`,
      data,
      options
    );
  }

}
